/**
 * Creates an array of product attributes
 * @param {Object} product
 */
function setAttributes(product) {
  const attributes = [
    {
      key: '_short_description',
      value: product.subtitle,
    },
  ];
  if (product.variants[0].compareAtPrice) {
    attributes.push({
      key: '_compare_price',
      value: product.variants[0].compareAtPrice?.amount,
    });
  }
  return attributes.filter((el) => el.value);
}

export default setAttributes;
